import { defineStore } from 'pinia';
import { useDeviceStore } from './modules/device';

export const useMainStore = defineStore('main', {
  state: () => ({
    enabled: true, // 是否启用全局进度
    unitList: [], // stack unit列表
    unit: '', // 选中的unit
    unitModel: '', // 选中的unit model名称
  }),
  getters: {
    unitModelTip(state) {
      const deviceStore = useDeviceStore();
      const model = state.unitModel || deviceStore.deviceInfo.model;
      const name = deviceStore.deviceInfo.name;
      return name ? `${model} ( ${name} )` : model;
    },
    unitModelInfo(state) {
      const deviceStore = useDeviceStore();
      const model = state.unitModel || deviceStore.deviceInfo.model;
      const name = deviceStore.deviceInfo.name;
      return name ? `${model} ( ${name.length > 32 ? name.substring(0, 32) + '...' : name} )` : model;
    },
  },
  actions: {
    setUnitList(newList) {
      this.unitList = newList;
    },
    setUnit(unit) {
      this.unit = unit;
    },
    setUnitModel(unitModel){
      this.unitModel = unitModel;
    }
  },
});

export { useAccessToolsStore } from './modules/accessTools';
export { useConfigurationStore } from './modules/configuration';
export { useDeviceStore } from './modules/device';
export { useFirmwareStore } from './modules/firmware';
export { useLicenseStore } from './modules/license';
export { useLogsStore } from './modules/logs';
export { useMirroringStore } from './modules/mirroring';
export { useMulticastStore } from './modules/multicast';
export { useNeighborStore } from './modules/neighbor';
export { useNetworksStore } from './modules/networks';
export { usePoeStore } from './modules/poe';
export { useSecurityStore } from './modules/security';
export { useStatisticsStore } from './modules/statistics';
export { useAuthStore } from './auth';
export { useUiStore } from './modules/uiStore';
export { userThemeStore } from './modules/theme';

